module.exports = __webpack_public_path__ + "static/media/figure4.37e462dc.jpg";